import moment from "moment";
import app from '../main.js'

/**
 * Formats a given date for human-readable display.
 *
 * @param {Date} inputDate - The input date to be formatted.
 * @param {boolean} exportTime - Whether to include the time part in the formatted output. Default is true.
 * @param {boolean} exportSeconds - Whether to include seconds in the time part. Default is false.
 * @param {boolean} exportMilliseconds - Whether to include milliseconds in the time part. Default is false.
 * @param {boolean} excluyedDay - Whether to exclude the day part in the formatted output. Default is false.
 * @returns {string} The formatted date according to the specified options.
 */
export function formatDateForHumans(inputDate, exportTime = true, exportSeconds = false, exportMilliseconds = false, excluyedDay = false)
{
  const locale = app.$i18n.locale;
  let dateFormat;

  switch (locale)
  {
    case 'es':
      dateFormat = excluyedDay ? 'MMMM YYYY' : 'MMMM D YYYY'      
      break;
    
    case 'fr':
      dateFormat = excluyedDay ? 'MMMM YYYY' : 'D MMMM YYYY'
      break;
  
    default:
      dateFormat = excluyedDay ? 'MMMM YYYY' : 'MMMM Do YYYY'
      break;
  }

  if(exportTime)
  {
    dateFormat = `${dateFormat} HH:mm`;
    
    if(exportSeconds)
    {
      dateFormat = `${dateFormat}:ss`;
    }
  }

  let response = moment(inputDate).locale(locale).format(dateFormat);

  if(exportSeconds && exportMilliseconds)
  {
    /**
     * Moment was rounding the milliseconds, beacuse that's not what we want, 
     * we will just take the millisecongs from the original inputdate 
     * and we will just place on the formatted response
     */
    const dateArray = inputDate.split('.');

    if(Array.isArray(dateArray) && dateArray.length === 2) {
      const milliseconds = dateArray[1];
      response = `${response}.${milliseconds}`;
    }
  }

  return response;
}

/**
 * Calculates the age based on the input date.
 *
 * @param {Date} inputDate - The input date to calculate the age from.
 * @returns {number} The calculated age.
 */
export function getAge(inputDate) 
{
  var today = new Date();
  var dob = new Date(inputDate);
  var age = today.getFullYear() - dob.getFullYear();
  var month = today.getMonth() - dob.getMonth();
  var day = today.getDate() - dob.getDate();

  if (month < 0 || (month === 0 && day < 0)) {
      age--;
  }

  return age;
}

/**
 * Converts the first letter of a word to uppercase and the rest to lowercase.
 *
 * @param {string} word - The word to be converted.
 * @returns {string} The converted word.
 */
export function typeTitle(word) {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

/**
 * Gets the range date for a given start and end date.
 *
 * @param {string} startDate - The start date.
 * @param {string} endDate - The end date.
 * @returns {string} The range date.
 */
export function getRangeDate(startDate, endDate) {
  
  const locale = app.$i18n.locale;

  let monthStartDate = typeTitle(moment(startDate).locale(locale).format('MMM'));
  let dayStartDate = moment(startDate).locale(locale).format('D');
  let monthEndDate = typeTitle(moment(endDate).locale(locale).format('MMM'));
  let dayEndDate = moment(endDate).locale(locale).format('D');
  let rangeDate = `${monthStartDate} ${dayStartDate} - ${monthEndDate == monthStartDate ? dayEndDate : `${dayEndDate} ${monthEndDate}`}`;
  
  return rangeDate
}

/**
 * Gets the date title for a given date.
 *
 * @param {string} date - The date.
 * @returns {string} The date title.
 */
export function getDateTitle(date) {

  const locale = app.$i18n.locale;
  const dateFormat = 'ddd D';
  return moment(date).locale(locale).format(dateFormat).toUpperCase();

}